import { createFileRoute, Navigate } from '@tanstack/react-router';

/** @deprecated */
export const Route = createFileRoute('/(redirects)/checkout')({
  component: () => <Navigate to="/store/connect" />,
});
